<template>
    <!--<div id="allmap" style="width: 100%; height: {{mapHeight}}px"></div>-->
    <!--<div id="allmap":style="{width: '100%', height: mapHeight + 'px'}"></div>-->
    <div id="allmap" style="width: 825px; height: 422px;"></div>

</template>

<script>

    export default {
        name: "BMapComponent",
        data:function(){
            return{
                mapStyle:{
                    // width:'100%',
                    // height:this.mapHeight +'px'
                }
            }
        },

        // ready:function(){
        //     var map =newBMap.Map("allmap");
        //     var point =newBMap.Point(this.longitude,this.latitude);
        //     var marker =newBMap.Marker(point);
        //     map.addOverlay(marker);
        //     map.centerAndZoom(point,15);
        //     var point = new BMap.Point(116.365, 39.972)
        //     // 信息窗的配置信息
        //     var opts ={
        //         width :250,
        //         height:75,
        //         title :"地址：司马达拓（深圳）智能系统有限公司",
        //     }
        //     var infoWindow =newBMap.InfoWindow(this.description, opts);// 创建信息窗口对象
        //     marker.addEventListener("click",function(){
        //         map.openInfoWindow(infoWindow,point);
        //     });
        //     map.enableScrollWheelZoom(true);
        //     map.openInfoWindow(infoWindow,point);//开启信息窗口
            
        // },
          mounted() {

                  // 百度地图API功能
                 var map = new BMap.Map("allmap");
                 var point = new BMap.Point(116.3656922271,39.9728815165);
                 map.centerAndZoom(point, 18);
                 map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
                 var marker = new BMap.Marker(point);  // 创建标注
                 map.addOverlay(marker);               // 将标注添加到地图中
                //  marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画

                 // 添加带有定位的导航控件
                 var navigationControl = new BMap.NavigationControl({
                     // 靠左上角位置
                     anchor: BMAP_ANCHOR_TOP_LEFT,
                     // LARGE类型
                     type: BMAP_NAVIGATION_CONTROL_LARGE,
                     // 启用显示定位
                     enableGeolocation: true
                 });
                 map.addControl(navigationControl);
                 //解决标注点不居中的问题
                 map.panBy(412, 211);//中心点偏移多少像素（width,height）为div 宽高的1/2;

          }

        
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BMapComponent/BMapComponent.vue